import lodash from 'lodash'
import React, { ReactElement, useMemo } from 'react'
import styled from 'styled-components'

import {
  Col,
  FormRow,
} from '../../../../../../1stlog-ui/src/components/Bootstrap'
import Field, {
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import Icon from '../../../../../../1stlog-ui/src/components/Icon'
import Input from '../../../../../../1stlog-ui/src/components/Input'
import { AdditionalContacts } from './AdditionalContacts'

const Wrapper = styled.div``

type TContactProps = {
  addressField: string
  isPickup: boolean
}

const Contact = (props: TContactProps): ReactElement => {
  const { addressField, isPickup } = props

  const emailField = `${addressField}.mail`
  const phoneField = `${addressField}.phone1`

  const phone = useField(phoneField, { onlyValid: true })
  const email = useField(emailField, { onlyValid: true })

  const clientNotifications = useField('clientNotifications')

  const showPhoneWarning = useMemo(() => {
    return (
      lodash.some(clientNotifications, (n) => n.isEnabled && Boolean(n.sms)) &&
      !phone
    )
  }, [clientNotifications, phone])

  const showEmailWarning = useMemo(() => {
    return (
      lodash.some(
        clientNotifications,
        (n) => n.isEnabled && Boolean(n.email),
      ) && !email
    )
  }, [clientNotifications, email])

  const showPhone = useMemo(
    () => lodash.some(clientNotifications, (n) => n.isEnabled && n.phone),
    [clientNotifications],
  )

  const showEmail = useMemo(
    () => lodash.some(clientNotifications, (n) => n.isEnabled && n.email),
    [clientNotifications],
  )

  return (
    <Wrapper>
      <FormRow>
        {showPhone && (
          <Col md={6} lg={6}>
            <Field
              name={phoneField}
              label={i18n.t('notification_sms', 'Telefonnummer')}
            >
              <Input />
            </Field>
            {showPhoneWarning && (
              <div className="text-warning mb-1">
                <Icon icon="fas fa-exclamation-triangle" />{' '}
                {i18n.t(
                  'no_sms_notifications_without_phonenumber',
                  'Ohne Telefonnummer werden keine Benachrichtigungen per SMS versendet.',
                )}
              </div>
            )}
          </Col>
        )}
        {showEmail && (
          <Col md={6} lg={6}>
            <Field
              name={emailField}
              label={i18n.t('notification_email', 'E-Mail')}
            >
              <Input />
            </Field>
            {showEmailWarning && (
              <div className="text-warning mb-1">
                <Icon icon="fas fa-exclamation-triangle" />{' '}
                {i18n.t(
                  'no_email_notifications_without_email',
                  'Ohne E-Mail Adresse werden keine Benachrichtigungen per E-Mail versendet.',
                )}
              </div>
            )}
          </Col>
        )}
      </FormRow>
      {showPhone && showEmail && (
        <FormRow>
          <Col>
            <p className="text-muted">
              {i18n.t('info_notification_contact_sync', {
                defaultValue:
                  'Die hier angegebenen Kontaktdaten werden automatisch mit den Feldern oben bei der {{addressType}} synchronisiert.',
                addressType: isPickup
                  ? i18n.t('addresstype_sender_address', 'Absenderadresse')
                  : i18n.t('addresstype_receiver_address', 'Empfängeradresse'),
              })}
            </p>
          </Col>
        </FormRow>
      )}
      <div className="m-n1">
        <AdditionalContacts
          showPhone={showPhone}
          showEmail={showEmail}
          hasPhone={Boolean(phone)}
          hasEmail={Boolean(email)}
        />
      </div>
    </Wrapper>
  )
}

export default Contact
